import { render, staticRenderFns } from "./ProfitLossReport.vue?vue&type=template&id=22c963ce"
import script from "./ProfitLossReport.vue?vue&type=script&lang=js"
export * from "./ProfitLossReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports